<template>
    <div class="page-container">
        <div class="page-header content-fade-in">
            <div class="title">欢迎使用会声智达</div>
            <div class="subtitle">语音转文字 · 识别发言人 · 智能总结</div>
        </div>
        
        <div class="dashboard-main">
            <div class="tab-section content-slide-up" style="animation-delay: 0.1s;">
                <div class="tab-item realtime-meeting card-item card-shimmer" v-on:click="goaddmeeting">
                    <img class="tab-item-icon" :src="meetingLeft" />
                    <div class="tab-item-content">
                        <div class="name">实时会议</div>
                        <div class="desc">开展实时会议，AI识别发言人及发言内容，即时生成总结</div>
                    </div>
                    <div class="action-icon">
                        <i class="arrow-right"></i>
                    </div>
                </div>
                <div class="tab-item upload-audio card-item card-shimmer" v-on:click="goupload">
                    <img class="tab-item-icon" :src="audioLeft" />
                    <div class="tab-item-content">
                        <div class="name">上传录音</div>
                        <div class="desc">选择本地音频文件上传，AI即时转写并进行总结</div>
                    </div>
                    <div class="action-icon">
                        <i class="arrow-right"></i>
                    </div>
                </div>
            </div>
            
            <div class="content-container-dashboard">
                <!-- 搜索栏 -->
                <div class="search-container">
                    <div class="input-wrapper">
                        <a-input v-model:value="searchQuestion" @pressEnter="goToDeepSeek" placeholder="请输入您想要搜索的问题" />
                        <a-button class="search-btn" type="primary" @click="goToDeepSeek">搜索</a-button>
                    </div>
                </div>
                
                <!-- 常见问题区域 -->
                <div class="qa-container">
                    <div class="section-title">常见问题</div>
                    
                    <a-collapse v-model:activeKey="activeKey" accordion class="faq-collapse">
                        <a-collapse-panel v-for="item in questions" :key="item.id" :header="item.title">
                            <div class="answer-content" v-html="item.answer"></div>
                        </a-collapse-panel>
                    </a-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import meetingLeft from '@/assets/images/realtime-meeting-left.png';
import audioLeft from '@/assets/images/upload-audio-left.png';

// 路由
const router = useRouter()

// 常见问题数据
const questions = ref([
    {
        id: 1,
        title: '什么是会声智达?',
        answer: `会声智达是一款专为会议设计的人工智能工具，它通过集成先进的声学技术和人工智能算法，提供了一系列强大的功能来优化会议体验。会声智达具备如下特点：<br>
                    <ul class="detail-points">
                        <li><strong>智能语音识别</strong>: 会声智达能够实时将会议中的语音转换成文字，提供准确的语音识别和转录服务。</li>
                        <li><strong>会议记录与总结</strong>: 自动记录会议内容，并能够智能地提炼关键点和总结，方便用户会后查阅和回顾。</li>
                        <li><strong>本地化部署</strong>: 支持在客户本地服务器上部署，确保会议数据的安全性和隐私性。</li>
                    </ul>`
    },
    {
        id: 2,
        title: '会声智达如何实现会议纪要?',
        answer: `会声智达通过以下步骤实现会议纪要：<br>
                    <ul class="detail-points">
                        <li><strong>实时转录</strong>: 在会议进行中，系统实时捕捉音频并将其转换为文字记录。</li>
                        <li><strong>说话人分离</strong>: 利用声纹识别或多通道音频处理技术，区分不同发言人。</li>
                        <li><strong>智能分析</strong>: 对转录文本进行自然语言处理，提取关键议题、待办事项和决策点。</li>
                        <li><strong>纪要生成</strong>: 基于分析结果，自动生成结构化、重点突出的会议纪要初稿，用户可在此基础上进行编辑和确认。</li>
                    </ul>`
    },
    {
        id: 3,
        title: '会声智达如何保护客户数据安全?',
        answer: `我们高度重视数据安全与隐私保护：<br>
                    <ul class="detail-points">
                        <li><strong>本地化部署</strong>: 核心优势在于支持完全本地化部署，所有音视频数据和处理结果都存储在客户指定的服务器上，不经过公有云，最大程度保障数据主权和安全。</li>
                        <li><strong>权限管理</strong>: 系统内置严格的权限控制机制，确保只有授权用户才能访问相关会议数据和纪要。</li>
                        <li><strong>数据加密</strong>: 在数据传输和存储过程中，可根据需求配置加密措施，防止数据泄露。</li>
                        <li><strong>合规性</strong>: 遵循相关数据保护法规，确保产品设计和运营符合安全合规要求。</li>
                    </ul>`
    }
])

// 折叠面板的activeKey
const activeKey = ref([])

// 跳转函数
const goaddmeeting = () => {
    router.push('/addmeeting')
}

const goupload = () => {
    router.push('/upload')
}

// 搜索相关
const searchQuestion = ref('')
const goToDeepSeek = () => {
    if (searchQuestion.value) {
        router.push({
            path: '/deepseek',
            query: { question: searchQuestion.value }
        })
    }
}
</script>

<style scoped lang="less">
.page-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px;
}

/* 内容容器样式 */
.content-container-dashboard {
    border-radius: 12px;
    padding: 24px;
    height: calc(100% - 100px);
    display: flex;
    flex-direction: column;
}

.dashboard-main {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    .tab-section {
        display: flex;
        padding: 24px;
        gap: 24px;
        flex-shrink: 0;

        .tab-item {
            flex: 1;
            border-radius: 12px;
            height: 130px;
            background: #F0F7FF;
            display: flex;
            align-items: center;
            padding: 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            border: 1px solid #E2E8F0;

            .tab-item-icon {
                width: 80px;
                height: 80px;
                margin-right: 20px;
                transition: transform 0.3s ease;
            }

            .tab-item-content {
                flex: 1;
            }

            .name {
                font-size: 18px;
                font-weight: 600;
                color: #0F172A;
                margin-bottom: 8px;
            }

            .desc {
                font-size: 14px;
                color: #64748B;
                line-height: 1.6;
            }

            .action-icon {
                position: absolute;
                right: 24px;
                top: 50%;
                transform: translateY(-50%);
                opacity: 0;
                transition: all 0.3s ease;
            }

            .arrow-right {
                display: inline-block;
                width: 20px;
                height: 20px;
                border-top: 2px solid #246BF0;
                border-right: 2px solid #246BF0;
                transform: rotate(45deg);
            }

            &:hover {
                box-shadow: 0 4px 16px rgba(36, 107, 240, 0.15);
                border-color: #246BF0;
                background: linear-gradient(to right, #F0F7FF, #E0F2FE);

                .tab-item-icon {
                    transform: scale(1.05);
                }

                .action-icon {
                    opacity: 1;
                    right: 20px;
                }
            }
        }
    }
    

    .search-container {
        margin-bottom: 30px;
        
        .search-title {
            font-size: 18px;
            font-weight: 600;
            color: #0F172A;
            margin-bottom: 16px;
        }

        .input-wrapper {
            display: flex;
            align-items: stretch;
            
            .ant-input {
                height: 46px;
                font-size: 15px;
                padding: 0 20px;
                border-radius: 8px 0 0 8px !important;
                border-right: none;
                box-sizing: border-box;
                line-height: normal;
            }
            
            .search-btn {
                height: 46px;
                min-height: 46px;
                width: 100px;
                border-radius: 0 8px 8px 0 !important;
                font-weight: 500;
                font-size: 15px;
                background: #246BF0;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
                box-sizing: border-box;
                border: 1px solid #246BF0;
                border-left: none;
                line-height: 1;
            }
        }
    }

    // 问答区域
    .qa-container {
        flex: 1;
        display: flex;
        flex-direction: column;
    }
    
    .section-title {
        font-size: 18px;
        font-weight: 600;
        color: #0F172A;
        margin-bottom: 16px;
    }
    
    .faq-collapse {
        background-color: transparent;
        border: none;

        :deep(.ant-collapse-item) {
            background-color: #fff;
            border-radius: 8px;
            border: 1px solid #e5e7eb;
            margin-bottom: 16px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);

            &:last-child {
                margin-bottom: 0;
            }

            .ant-collapse-header {
                font-weight: 600;
                font-size: 16px;
                color: #1f2937;
                padding: 16px 20px;
                border-radius: 8px 8px 0 0;
                align-items: center;
                border-bottom: none !important;
            }

            &.ant-collapse-item-active .ant-collapse-header {
                border-bottom: 1px solid #f0f0f0 !important;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }

            .ant-collapse-content {
                background-color: #fff;
                border-top: none;
                border-radius: 0 0 8px 8px;

                .ant-collapse-content-box {
                    padding: 20px;
                }
            }
        }

        :deep(.ant-collapse-borderless) {
            background-color: transparent;
        }
    }
    
    .answer-content {
        font-size: 14px;
        line-height: 1.8;
        color: #334155;

        strong {
            color: #111827;
        }
    }
    
    .detail-points {
        margin-top: 16px;
        padding-left: 24px;
        
        li {
            margin-bottom: 12px;
        }
    }
}
</style>
